import { HeaderValuesType } from '@cxc/react-fpds-components';

const IncentiveTableColumnConstants: HeaderValuesType = [
    {
        id: 'incentive-name',
        textValue: 'Name',
        contentAlignment: 'left',
    },
    {
        id: 'status',
        textValue: 'Status',
        contentAlignment: 'left',
    },
    {
        id: 'potential-value',
        textValue: 'Potential Value',
        contentAlignment: 'left',
    },
    {
        id: 'grantor',
        textValue: 'Grantor',
        contentAlignment: 'left',
    },
    {
        id: 'eligible-equipment',
        textValue: 'Eligible Equipment',
        contentAlignment: 'left',
    },
    {
        id: 'incentive-type',
        textValue: 'Type',
        contentAlignment: 'left',
    },
];

export default IncentiveTableColumnConstants;
